export default __webpack_public_path__ + "static/media/trade-convert.d34d5644.jpg";